var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cd312c",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#377d41",
    d: "M10 24v-8h20v4q0 .52-.13 1H30v3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 8H10V0h20zm-21.78.67c-.58-.6-1.77-1.19-2.21-2.12-.05-.25.1-.51.28-.64.02.39.57.11.75.1-.15.4 1.1.13 1.23.2.21.03.08-.52.11-.62 0-.17-1.5-.26-1.34.1-.18.04-.2-.18-.46-.15 1.73-2.93 1.11-3.08-.5-.2l.04.01c-.21.32-.02-.35-.1-.48v-.1c-.12.01-.28-.06-.26-.17h-.04v-.2h-.04v-.36h-.03v-.23c.41-.48.59-.41-.14-.82-.7.4-.55.32-.18.82h.01v.23h-.03v.36h-.04v.18h-.04c.02.1-.1.2-.25.19v.16c-.13.18.06.36-.03.54l-.09-.13.05-.02c-1.6-2.84-2.25-2.74-.53.18-.25-.01-.25.2-.45.15.13-.36-1.08-.2-1.22-.18-.19.04-.11.53-.12.63 0 .16 1.54.27 1.34-.13.2 0 .57.26.75 0a.5.5 0 0 1 .28.26h-.01c0 .25-1.2.2-1.3.2l-.13.01c-1 .07.45.71.45.71l.44.1c-1.2.88-1.64 2.06-.53 1.08 0 0 .76-.87 1.27-1.03.07-.01.57-.2.6-.22.47.48.95.87 1.17 1.1.22.22 2.06 1.22 1.3.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOman);
export default __webpack_public_path__ + "static/media/oman.0d793e3fc916651113547128bfa2e64d.svg";
export { ForwardRef as ReactComponent };